import comp from "./ScheduleEvent";
export default comp;
